import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productYourReports: [
    {
      title: "List of all products by store",
    },
    {
      title: "List of products that are least competitive",
      label: "expensive",
    },
    {
      title: "List of products that are most competitive",
      label: "cheapest",
    },
  ],
};

const productYourReportsSlice = createSlice({
  name: "productYourReports",
  initialState,
  reducers: {
    addReport: (state, action) => {
      state.productYourReports.push(action.payload);
    },
    updateReport: (state, action) => {
      const { index, report } = action.payload;
      state.productYourReports[index] = report;
    },
    removeReport: (state, action) => {
      const { reportIndex } = action.payload;
      const newState = state.productYourReports.filter(
        (_, i) => i != reportIndex
      );
      state.productYourReports = newState;
    },
  },
});

export const { addReport, updateReport, removeReport } =
  productYourReportsSlice.actions;

export default productYourReportsSlice.reducer;
